import { useLearningObjectSEO } from '@hendrx/core/common/hooks/learningObject/useLearningObjectSEO';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio')({
  component: StudioLayout
});

function StudioLayout() {
  useLearningObjectSEO({});
  return <Outlet />;
}
